export class Version {
  private static version = getVersionString();
  private static accessed = false;

  static get() {
    this.accessed = true;

    return this.version;
  }

  static setPostfix(postFix: string) {
    if (this.accessed) {
      throw Error("can't set postfix after reading version");
    }

    this.version += `-${postFix}`;
  }
}

function getVersionString(): string {
  try {
    return process.env.npm_package_version || "unknown";
  } catch (e) {
    return require("../package.json").version;
  }
}
